import React, { useEffect, useState } from "react";
import "./VerProducto.css";
import { useParams, useNavigate, NavLink } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const VerProducto = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [datosProducto, setDatosProducto] = useState(null);
  const [imagenPrincipal, setImagenPrincipal] = useState("");
  const [comentariosList, setComentariosList] = useState([]);
  const [comentario, setComentario] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [cantidad, setCantidad] = useState(1);
  const [cargando, setCargando] = useState(true);
  const [datosCategoriasProductos, setDatosCategoriasProductos] = useState([]);

  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const renovarToken = async () => {
    try {
      const res = await fetch(`${API}/user/refresh`, {
        method: "POST",
        credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

  const traerDatos = async () => {
    try {
      let response = await fetch(`${API}/productos/getProducto/${id}`);
      if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) {
          response = await fetch(`${API}/productos/getProducto/${id}`);
        } else {
          handleLogout();
          return;
        }
      }
      const data = await response.json();
      setDatosProducto(data.datos);
      setImagenPrincipal(data.datos.imagenesURLs?.[0]);
      if (data.datos?.categoriaDTO?.id) traerRelacionados(data.datos.categoriaDTO.id);
    } catch (error) {
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const traerRelacionados = async (catId) => {
    try {
      let res = await fetch(`${API}/productos/traerProductosCategoria/${catId}`);
      if (res.status === 403) {
        const renovado = await renovarToken();
        if (renovado) {
          res = await fetch(`${API}/productos/traerProductosCategoria/${catId}`);
        }
      }
      const data = await res.json();
      setDatosCategoriasProductos((data.content || []).filter(p => p.id !== parseInt(id)));
    } catch (error) {
      console.error(error);
    }
  };

  const traerComentarios = async () => {
    try {
      let res = await fetch(`${API}/comentarios/traerComentarioProducto/${id}`);
      if (res.status === 403) {
        const renovado = await renovarToken();
        if (renovado) {
          res = await fetch(`${API}/comentarios/traerComentarioProducto/${id}`);
        }
      }
      const data = await res.json();
      setComentariosList(data.content || []);
    } catch (err) {
      console.error(err);
    }
  };

  const enviarComentario = async (e) => {
    e.preventDefault();
    if (!token) { navigate("/login"); return; }
    if (!comentario.trim()) return;

    const enviarPeticion = async (tokenActual) => {
      return await fetch(API + "/comentarios/crearComentario", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenActual}`
        },
        body: JSON.stringify({ comentario, usuarioId: user?.id, productoId: id })
      });
    };

    try {
      let response = await enviarPeticion(token);
      if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) {
          response = await enviarPeticion(localStorage.getItem("token"));
        } else {
          handleLogout();
          return;
        }
      }
      if (response.ok) {
        setComentario("");
        setMostrar(false);
        traerComentarios();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const agregarAlCarrito = async () => {
    if (!datosProducto) return;
    const item = {
      id: datosProducto.id,
      nombre: datosProducto.nombre,
      precio: datosProducto.precio,
      imagenUrl: datosProducto.imagenesURLs[0],
      cantidad
    };

    if (token) {
      const enviarCarrito = async (tokenActual) => {
        return await fetch(`${API}/api/carrito/agregarCarrito`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${tokenActual}`
          },
          body: JSON.stringify({ productoId: datosProducto.id, cantidad })
        });
      };
      let res = await enviarCarrito(token);
      if (res.status === 403) {
        const renovado = await renovarToken();
        if (renovado) {
          res = await enviarCarrito(localStorage.getItem("token"));
        } else {
          handleLogout();
          return;
        }
      }
      if (res.ok) navigate("/carrito");
    } else {
      let carrito = JSON.parse(localStorage.getItem("carrito")) || [];
      const index = carrito.findIndex(p => p.id === item.id);
      index > -1 ? carrito[index].cantidad += cantidad : carrito.push(item);
      localStorage.setItem("carrito", JSON.stringify(carrito));
      navigate("/carrito");
    }
  };

  useEffect(() => {
    traerDatos();
    traerComentarios();
    window.scrollTo(0, 0);
  }, [id]);

  if (cargando) return <div className="loading-state">Cargando producto...</div>;
  if (!datosProducto) return <div className="error-state">Producto no encontrado</div>;

  return (
    <div className="product-view-container">
      <section className="ver-producto">
        {/* GALERÍA */}
        <div className="producto-galeria">
          <div className="main-image-wrapper">
            <img src={`${API}${imagenPrincipal}`} alt={datosProducto.nombre} className="imagen-principal" />
          </div>
          <div className="miniaturas-grid">
            {datosProducto.imagenesURLs?.map((img, index) => (
              <div
                key={index}
                className={`miniatura-item ${imagenPrincipal === img ? "activa" : ""}`}
                onClick={() => setImagenPrincipal(img)}
              >
                <img src={`${API}${img}`} alt={`vista-${index}`} />
              </div>
            ))}
          </div>
        </div>

        {/* INFO DETALLE */}
        <div className="producto-info-detalle">
          <span className="brand-tag">{datosProducto.marca}</span>
          <h1 className="producto-titulo">{datosProducto.nombre}</h1>

          <div className="precio-container">
            {datosProducto.precioAnterior && (
              <span className="precio-tachado">
                ${datosProducto.precioAnterior.toLocaleString('es-CO')}
              </span>
            )}
            <span className="precio-actual">
              ${datosProducto.precio.toLocaleString('es-CO')}
            </span>
          </div>

          {/* STOCK LIMPIO SIN CÍRCULO */}
          <p className={datosProducto.stock <= 10 ? "stock-bajo" : "stock-normal"}>
            {datosProducto.stock <= 10 ? `Últimas ${datosProducto.stock} unidades` : `${datosProducto.stock} disponibles`}
          </p>

          <div className="descripcion-section">
            <h4>Descripción</h4>
            <div>
              {datosProducto.descripcion.split('.').map((frase, index, array) => (
                <span key={index}>
                  {frase}
                  {index < array.length - 1 && <><br /><br /></>}
                </span>
              ))}
            </div>
          </div>

          <div className="compra-acciones">
            <div className="cantidad-selector">
              <button onClick={() => setCantidad(Math.max(1, cantidad - 1))}>-</button>
              <span>{cantidad}</span>
              <button onClick={() => setCantidad(Math.min(datosProducto.stock, cantidad + 1))}>+</button>
            </div>
            <button
              onClick={agregarAlCarrito}
              className="btn-add-cart"
              disabled={datosProducto.stock <= 0}
            >
              {datosProducto.stock > 0 ? "Agregar al Carrito" : "Agotado"}
            </button>
          </div>
        </div>
      </section>

      {/* COMENTARIOS */}
      <section className="comentarios-section">
        <div className="comentarios-header">
          <h3>Opiniones de clientes ({comentariosList.length})</h3>
          <button className="btn-toggle-comentario" onClick={() => !token ? navigate("/login") : setMostrar(!mostrar)}>
            {mostrar ? "Cancelar" : "Escribir comentario"}
          </button>
        </div>

        {mostrar && (
          <div className="comentario-form">
            <textarea
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              placeholder="¿Qué tal te pareció el producto?"
              rows={4}
            />
            <button className="btn-enviar" onClick={enviarComentario}>Publicar Comentario</button>
          </div>
        )}

        <div className="comentarios-list"> 
          {comentariosList.length > 0 ? (
            comentariosList.map((el, index) => {
              const esMio = user && el.userDTO?.id === user.id;
              return (
                <div key={index} className={`comentario-card ${esMio ? "own-comment" : ""}`}>
                  <div className="comentario-avatar">{el.userDTO?.nombre?.charAt(0).toUpperCase()}</div>
                  <div className="comentario-contenido">
                    <div className="comentario-meta">
                      <strong>{el.userDTO?.nombre} {esMio && "(Tú)"}</strong>
                      <span>• {new Date(el.horaCreacion).toLocaleString()}</span>
                    </div>
                    <p>{el.comentario}</p>
                  </div>
                </div>
              );
            })
          ) : <p className="no-comments">Nadie ha comentado aún.</p>}
        </div>
      </section>

      {/* RELACIONADOS */}
      <div className="relacionados-container" style={{ padding: '20px' }}>
        <h3>También te puede gustar</h3>
        <div className="productos-gridIndex">
                  { datosCategoriasProductos.length > 0 ? (datosCategoriasProductos.map(p => (
                      <div className="producto-cardIndex" key={p.id}>
                        <div className="card-imgIndex">
                          <img
                            src={`${API}${p.imagenesURLs?.[0]}`}
                            alt={p.nombre}
                            onError={(e) => { e.target.src = 'https://via.placeholder.com/300'; }}
                          />
                        </div>
                        <div className="card-bodyIndex">
                          <h4 className="nombre-ajustado">{p.nombre}</h4>
                          
                          {/* STOCK LIMPIO SIN CÍRCULO */}
                          <p className={p.stock <= 10 ? "stock-bajo" : "stock-normal"}>
                            {p.stock <= 10 ? `Últimas ${p.stock} unidades` : `${p.stock} disponibles`}
                          </p>
        
                          {p.precioAnterior && (
                            <p className="card-price precio-tachado-rojo">
                              {new Intl.NumberFormat("es-CO", {
                                style: "currency",
                                currency: "COP",
                                minimumFractionDigits: 0
                              }).format(p.precioAnterior)}
                            </p>
                          )}
        
                          <p className="card-price">
                            {new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 }).format(p.precio)}
                          </p>
        
                          <NavLink to={`/verProducto/${p.id}`} className="btn-detail">Ver producto</NavLink>
                        </div>
                      </div>
                    ))) :(
                      <p>no hay productos de esta categoria</p>
                    )}
                </div>
      </div>
    </div>
  );
};

export default VerProducto;